import globals from "./globals";
import $ from "cash-dom";
import Swiper, { EffectFade, Manipulation, Navigation } from "swiper";

const component = (function () {
    $(document).ready(function () {
        $("[data-action='lightbox-single']").on("click", function (_e) {
            var html = $(_e.target).parents("figure").find("img").clone();
            $(".lightbox-media").append(html);
            $(".lightbox").addClass("on").removeClass("pointer-none");
            $(".lighbox [data-action='close']").removeClass("pointer-none");
            $("body").addClass("locked");
        });

        /**
         * Initialize contextual slider
         */

        $('.layout-image-gallery [data-action="lightbox-slider"]').on("click", function (_e) {
            var container = $(_e.target).closest(".image-gallery")[0];
            var initialIndex = $(_e.target).closest(".image-gallery-image").attr("data-index");
            var slider = $(".lightbox-media");
            var slides = $(container).find(".image-gallery-image");
            var buttonPrev = $(".lightbox-button-prev")[0];
            var buttonNext = $(".lightbox-button-next")[0];
            var swiperInstance;

            // Populate slider
            slides.each(function () {
                var index = $(this).attr("data-index");
                var html = $(this).find(".image-element").html();
                var caption = $(this).find(".source-image").attr("title");

                slider.append(`<div class="swiper-slide aspect-square">${html}</div>`);

                if (caption.length) {
                    var appendClass = index === initialIndex ? "fade-in on" : "hidden";
                    $(".lightbox-description").append(
                        `<div class="caption c-white ${appendClass} transition-sm" data-describes="${index}">${caption}</div>`
                    );
                }
            });

            // Initialize slider
            swiperInstance = new Swiper(".lightbox-content", {
                effect: "fade",
                initialSlide: initialIndex,
                modules: [EffectFade, Manipulation, Navigation],
                navigation: {
                    nextEl: buttonNext,
                    prevEl: buttonPrev,
                    disabledClass: "button-disabled",
                },
            });

            // Display descriptions
            swiperInstance.on("slideChange", function () {
                var activeIndex = swiperInstance.activeIndex;
                $(".lightbox-description [data-describes]").removeClass("fade-in on").addClass("hidden");
                $(`.lightbox-description [data-describes='${activeIndex}']`)
                    .removeClass("hidden")
                    .addClass("fade-in on");
            });

            // Show slider
            $(".lightbox-controls").removeClass("hidden");
            $(".lightbox").addClass("on").removeClass("pointer-none");
            $(".lightbox [data-action='close']").removeClass("pointer-none");
            $("body").addClass("locked");
        });

        $(".lightbox [data-action='close']").on("click", function () {
            $(".lightbox-description [data-describes]").removeClass("on");
            $(".lightbox-controls").addClass("hidden");
            $(".lightbox-media").html(null);
            $(".lightbox-description").html(null);
            $(".lightbox").removeClass("on").addClass("pointer-none");
            $(".lightbox [data-action='close']").addClass("pointer-none");
            $("body").removeClass("locked");
        });

        $(window).on("keydown", function (e) {
            if (e.key == "Escape") {
                $(".lightbox-description [data-describes]").removeClass("on");
                $(".lightbox-controls").addClass("hidden");
                $(".lightbox-media").html(null);
                $(".lightbox-description").html(null);
                $(".lightbox").removeClass("on").addClass("pointer-none");
                $(".lightbox [data-action='close']").addClass("pointer-none");
                $("body").removeClass("locked");
            }
        });
    });
})();

export default component;
